// isoSize.js  ─────────────────────────────────────────────
// Return pixel dimensions for any ISO-A sheet at any DPI

export function isoAPixels(size = 'A3', dpi = 300) {
  // A0 = 841 × 1189 mm  (short × long)
  const A0 = { w: 841, h: 1189 };

  const n = Number(size.slice(1));          // 'A3' → 3
  const scale = 2 ** (n / 2);               // √2 per step
  const mmW = A0.w / scale;
  const mmH = A0.h / scale;

  const pxW = Math.round((mmW / 25.4) * dpi);
  const pxH = Math.round((mmH / 25.4) * dpi);

  return { width: pxW, height: pxH };       // portrait
}